"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.STEPS_PMC_DEFAULT = exports.STEPS_PMC_COVID_VACCINE = void 0;
var _States = require("./States");
/**
 * stateKey: refers to the state of the state machine
 * stepperLabelId: messages id if the step appears in the stepper. If null, step won't appear in the stepper
 * path: relative path that will be pushed onto history when this step is in the UI
 */

const STEPS_PMC_DEFAULT = exports.STEPS_PMC_DEFAULT = 'STEPS_PMC_DEFAULT';
const STEPS_PMC_COVID_VACCINE = exports.STEPS_PMC_COVID_VACCINE = 'STEPS_PMC_COVID_VACCINE';
// export const STEPS_PMAC_DEFAULT = 'STEPS_PMAC_DEFAULT'; // @TODO: ONLY HERE AS AN EXAMPLE STUB
var _default = exports.default = {
  [STEPS_PMC_DEFAULT]: [{
    stateKey: _States.apptInfo,
    stepperLabelId: 'stepperApptInfo',
    path: ''
  }, {
    stateKey: _States.apptTime,
    stepperLabelId: 'stepperApptTime',
    path: '/appt-time'
  }, {
    stateKey: _States.patientInfo,
    stepperLabelId: 'stepperPatientInfo',
    path: '/patient-info'
  }, {
    stateKey: _States.reviewAppt,
    stepperLabelId: 'stepperReviewAppt',
    path: '/review-appt'
  }, {
    stateKey: _States.apptSummary,
    stepperLabelId: null,
    path: '/appt-summary'
  }],
  [STEPS_PMC_COVID_VACCINE]: [{
    stateKey: _States.apptInfo,
    stepperLabelId: 'stepperApptInfo',
    path: ''
  }, {
    stateKey: _States.patientInfo,
    stepperLabelId: 'stepperPatientInfo',
    path: '/patient-info'
  }, {
    stateKey: _States.apptTime,
    stepperLabelId: 'stepperApptTime',
    path: '/appt-time'
  }, {
    stateKey: _States.reviewAppt,
    stepperLabelId: 'stepperReviewAppt',
    path: '/review-appt'
  }, {
    stateKey: _States.apptSummary,
    stepperLabelId: null,
    path: '/appt-summary'
  }]
};